<template>
    <a-spin :spinning="loading">
        <div class="modal-circle-box">
            <div class="modal-circle-theme">
                <span class="modal-circle-theme_label">主题筛选</span>
                <a-select class="width-160" v-model="params.tag_ids" placeholder="请选择主题" allowClear @change="themeChangeHandle">
                    <a-select-option v-for="item in themeList" :value="item.id" :key="item.id">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="modal-circle-list" @mousewheel="scrollChange" ref="scrollContainer">
                <div ref="scrollEle" v-if="postList.length">
                    <div class="modal-circle-item" v-for="item in postList" :key="item.id">
                        <div>
                            <span class="modal-circle-item_icon"></span>
                            <span class="modal-circle-item_name">{{
                                item.create_time | timeFromNow("YYYY-MM-DD")
                            }}/{{ item.author.name }}</span>
                        </div>
                        <div class="modal-circle-item_content" :class="{ 'cursour': fieldType === 'text' }"
                            v-if="item.content || item.tags.length" @click="selecteHandle(item)">
                            <span class="modal-circle-item_theme" v-for="tag in item.tags" :key="tag.id"># {{
                                tag.name
                            }}</span>
                            <span class="modal-circle-item_post">{{ item.content }}</span>
                            <span class="modal-circle-item_select" v-if="fieldType === 'text'">
                                <a-icon v-if="selectedId === item.id" class="modal-circle-item_select_icon"
                                    type="check-circle" theme="filled" />
                            </span>
                        </div>

                        <div class="modal-circle-item_imgs" v-if="imageMediaList(item.media_list).length">
                            <!-- <img v-for="media in item.media_list" :key="media.id" class="modal-circle-item_img" :src="media.thumbnail_url"> -->
                            <div v-for="(media, index) in imageMediaList(item.media_list)" :key="media.id" class="modal-circle-item_img"
                                :style="getBgStyle(media.thumbnail_url)" @click="viewPhoto(item.media_list, index)">
                                <div class="modal-circle-item_img_mask" v-if="fieldType === 'image'">
                                    <span class="modal-circle-item_img_select" @click.stop="selecteImageHandle(media)">
                                        <a-icon v-if="selectedImage.includes(media.id)"
                                            class="modal-circle-item_img_select_icon" type="check-circle"
                                            theme="filled" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a-divider v-if="!hasMore" class="modal-circle-divider">暂无更多数据</a-divider>
                </div>
                <a-empty v-else />
            </div>
            <app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />
        </div>
    </a-spin>
</template>

<script>
import ThemeService from "@/api/themeService"
import PostService from "@/api/postService"
import AppViewImg from "@/components/AppViewImg"

export default {
  name: "modalKlassCircle",
  components: { AppViewImg },
  props: {
    klassId: {
      type: String,
      default: ""
    },
    fieldType: {
      type: String,
      default: "text"
    },
    selectedView: {
      type: Array,
      default() {
        return []
      }
    },
    imageLen: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      imageList: [],
      imageIndex: 0,
      loading: false,
      hasMore: true,
      params: {
        limit: 10,
        tag_ids: undefined,
        after_id: undefined
      },
      themeList: [],
      postList: [],
      selectedId: undefined,
      selectedImage: []
    }
  },
  watch: {
    klassId: {
      handler() {
        this.initHandle()
      },
      immediate: true
    }
  },
  computed: {
    getBgStyle() {
      return function(thumbnail_url) {
        return {
          background: `#f5f5f5 url(${thumbnail_url}) no-repeat center center`,
          "background-size": "cover"
        }
      }
    },
    imageMediaList() {
      return function(source) {
        return source.filter(item => !item.content_type.startsWith("video"))
      }
    }
  },
  methods: {
    viewPhoto(source, index, type = "thumbnail_url") {
      if (!source[index][type] || !source[index][type].startsWith("http")) return
      this.imageList = source.filter(item => item[type] && item[type].startsWith("http")).map(item => item[type])
      this.imageIndex = this.imageList.findIndex(item => item === source[index][type])
    },

    initHandle() {
      this.loading = false
      this.hasMore = true
      this.postList = []
      this.getThemeList()
      this.getPostList()
    },

    getThemeList() {
      ThemeService.getThemeListService({
        klass_id: this.klassId
      }).then(res => {
        this.themeList = res || []
      })
    },

    getPostList() {
      if (this.loading || !this.hasMore) return
      this.loading = true
      PostService.getPostListService({ ...this.params, klassId: this.klassId })
        .then(res => {
          if (res.length >= this.params.limit) {
            this.params.after_id = res[res.length - 1].id
          } else {
            this.hasMore = false
          }
          this.loading = false
          this.postList = [...this.postList, ...res]
        })
        .catch(() => {
          this.loading = false
        })
    },

    scrollChange() {
      const containerH = this.$refs.scrollContainer.offsetHeight
      const contentH = this.$refs.scrollEle.offsetHeight
      const scrollTop = this.$refs.scrollContainer.scrollTop

      if (contentH - containerH - scrollTop > 20) {
        this.getPostList()
      }
    },

    themeChangeHandle() {
      this.params.after_id = undefined
      this.hasMore = true
      this.postList = []
      this.getPostList()
    },

    selecteHandle(item) {
      if (this.fieldType !== "text") {
        return
      }
      let selectedView = [...this.selectedView]
      if (this.selectedId === item.id) {
        this.selectedId = undefined
        selectedView = []
      } else {
        this.selectedId = item.id
        selectedView = [item]
      }
      this.$emit("update:selectedView", selectedView)
    },
    selecteImageHandle(item) {
      const index = this.selectedImage.indexOf(item.id)
      let selectedView = [...this.selectedView]
      if (index > -1) {
        this.selectedImage.splice(index, 1)
        selectedView.splice(index, 1)
      } else {
        this.selectedImage.push(item.id)
        selectedView.push(item)
      }

      if (this.selectedImage.length > this.imageLen) {
        this.selectedImage = this.selectedImage.slice(-this.imageLen)
        selectedView = selectedView.slice(-this.imageLen)
      }

      this.$emit("update:selectedView", selectedView)
    }
  }
}
</script>
<style lang="less" scoped>
.modal-circle {
  &-box {
    width: 750px;
    overflow-x: hidden;
  }

  &-list {
    width: 770px;
    height: calc(100vh - 300px);
    overflow-y: auto;
  }

  &-item {
    position: relative;

    &:before {
      position: absolute;
      content: "";
      width: 2px;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      top: 12px;
      left: 4px;
    }

    &_name {
      margin-left: 18px;
      color: #999;
    }

    &_theme {
      margin: 0 11px 0 7px;
      color: #01acfc;
    }

    &_content {
      margin: 10px 10px 10px 30px;
      padding: 15px 10px;
      background: #fff;
      cursor: pointer;
    }

    &_imgs {
      margin: 10px 10px 0 30px;
    }

    &_img {
      display: inline-block;
      position: relative;
      width: 190px;
      height: 156px;
      margin: 0 4px 5px 0;
      border-radius: 6px;
      cursor: pointer;

      &_mask {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.45);
      }

      &_select {
        position: absolute;
        width: 20px;
        height: 20px;
        right: 20px;
        bottom: 20px;
        border-radius: 50%;
        border: 1px solid #d9d9d9;
        cursor: pointer;
        background: #fff;

        &_icon {
          font-size: 19px;
          color: #1ab752;
        }
      }
    }

    &_icon {
      position: relative;
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #1890ff;
      z-index: 1;
    }

    &_select {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 40px;
      top: 45px;
      border-radius: 50%;
      border: 1px solid #d9d9d9;

      &_icon {
        font-size: 20px;
        color: #1ab752;
      }
    }
  }

  &-theme {
    margin-bottom: 20px;
    &_label {
      margin-right: 13px;
      color: #343c6a;
    }
  }

  &-divider {
    color: #999999 !important;
  }
}
</style>
